import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoutes = ({ children }) => {
  const userLogin = localStorage.getItem("userToken");
  return userLogin ? children : <Navigate to="/login" />;
};

export default PrivateRoutes;
